import { Theme } from '@24i/nxg-sdk-photon';
import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';
import { WEB_SCREEN_MAX_WIDTH } from '@24i/nxg-sdk-gluons/src/utils/constants';

import { BannerCarouselItemStyles } from './types';
import { RESPONSIVE_CONTAINER_HEIGHT } from '../../../styles/constants';

const getBannerCarouselItemStyles = (
    theme: Theme,
    isLandscape: boolean
): BannerCarouselItemStyles => ({
    bannerItemContainer: {
        position: 'relative',
        height: isLandscape ? RESPONSIVE_CONTAINER_HEIGHT.L : RESPONSIVE_CONTAINER_HEIGHT.M,
        ...(isLandscape && {
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                height: RESPONSIVE_CONTAINER_HEIGHT.M,
            },
        }),
    },
    slideInnerContainer: {
        paddingHorizontal: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    image: {
        flex: 1,
        backgroundColor: 'transparent',
        width: '100%',
    },
    textContainer: {
        position: 'absolute',
        height: '100%',
        justifyContent: 'flex-end',
        paddingBottom: isLandscape ? 250 : 32,
        paddingHorizontal: isLandscape ? 80 : 20,
        zIndex: 999,
        ...(isLandscape && {
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                paddingBottom: 64,
                paddingHorizontal: 32,
            },
        }),
        ...(!isLandscape && {
            [`@media (max-width: ${Breakpoint.SM}px)`]: {
                paddingHorizontal: 20,
            },
        }),
    },
    primaryButtonContainer: {
        marginTop: 22,
    },
    primaryButtonContainerWithTitle: {
        height: 54,
        alignSelf: 'flex-start',
        width: 'auto',
    },
    topGradient: {
        height: '30%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    bottomGradient: {
        height:
            window.innerWidth < WEB_SCREEN_MAX_WIDTH.XS
                ? RESPONSIVE_CONTAINER_HEIGHT.S
                : RESPONSIVE_CONTAINER_HEIGHT.L,
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
    },
    buttonContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    itemContainer: {
        width: '100%',
        backgroundColor: theme.color.background1,
        left: 0,
    },
    infoButtonContainer: {
        height: 54,
        paddingLeft: 24,
        alignSelf: 'flex-start',
        width: 'auto',
    },
    activityIndicator: { alignSelf: 'flex-start', marginTop: 22 },
    playButtonContainer: { flexDirection: 'row' },
    obscuredImageContainer: {
        height: '60%',
        width: '100%',
        position: 'absolute',
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default getBannerCarouselItemStyles;
